exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".streams-drawer-empty-state {\n  border: 1px solid #adb3b8;\n  text-align: center;\n  margin: 0 20px;\n}\n.streams-drawer-empty-state-uploads-image {\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n}\n.streams-drawer-empty-state-standard-image {\n  max-width: 200px;\n}\n", ""]);

